export default "__VITE_ASSET__BqvDo4oj__"